/**
 * @generated SignedSource<<91f25c8dd075885942f3be4408b1f222>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeleteAIGenerationButtonMutation$variables = {
  id: string;
};
export type DeleteAIGenerationButtonMutation$data = {
  readonly response: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
    readonly node: {
      readonly id: string;
    } | null;
  };
};
export type DeleteAIGenerationButtonMutation = {
  response: DeleteAIGenerationButtonMutation$data;
  variables: DeleteAIGenerationButtonMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": "response",
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "DeleteAIGenerationResponse",
    "kind": "LinkedField",
    "name": "deleteAIGeneration",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AIGeneration",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteAIGenerationButtonMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteAIGenerationButtonMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6771e7e67d4199960a1d2263e96e9627",
    "id": null,
    "metadata": {},
    "name": "DeleteAIGenerationButtonMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteAIGenerationButtonMutation(\n  $id: ID!\n) {\n  response: deleteAIGeneration(id: $id) {\n    node {\n      id\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6ded0bf175657640c3acdb91e99f34a7";

export default node;
